import React from 'react';
import Grid from '@mui/material/Grid';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import InventoryIcon from '@mui/icons-material/Inventory';
import PageLayout from '../../components/common/page-layout';
import DevicesOverviewTable from '../../components/tables/devices-overview-table';
import ActionCard from '../../components/common/action-card';

export default function Registery() {
  return (
    <PageLayout pageTitle="دستگاه‌ها">
      <Grid container spacing={3} sx={{ mb: 10 }}>
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard
            name="افزودن دستگاه‌های جدید"
            icon={<LibraryAddIcon />}
            path="/registery/insert"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard
            name="دستگاه‌های ثبت شده"
            icon={<InventoryIcon />}
            path="/registery/inserted-devices"
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item xs={10}>
          <DevicesOverviewTable />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
